import { render, staticRenderFns } from "./NuevaAsistencia.vue?vue&type=template&id=754ac199&scoped=true"
import script from "./NuevaAsistencia.vue?vue&type=script&lang=js"
export * from "./NuevaAsistencia.vue?vue&type=script&lang=js"
import style0 from "./NuevaAsistencia.vue?vue&type=style&index=0&id=754ac199&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754ac199",
  null
  
)

export default component.exports